import styled from 'styled-components';

export const StyledTextContainer = styled.div`
  margin-bottom: 1rem;
`;
